import { UUID } from "../generic/uuid";
import { UploadStatusEnum, UploadTypeEnum } from "@vini-wine/core-enums";
import { OrganisationModel } from "./organisation";
import { SupplierModel } from "./supplier";
import { UserAccountModel } from "./userAccount";
import { UploadVisibilityTypeModel } from "./uploadVisibilityType";
import { ImportFileHeaderModel } from "./importFileHeader";
import { UploadDto } from "@vini-wine/core-dtos";

export interface UploadModel extends UUID {
  // transform
  status: {
    id: UploadStatusEnum;
    statusUpdatedAt: Date;
  };
  type: {
    id: UploadTypeEnum;
  };
  name: string;
  validFrom: Date;
  validUntil: Date;
  numItems: number;
  createdAt: Date;

  // default includes
  organisation: OrganisationModel;
  organisationSupplier: SupplierModel;

  // available includes
  createdUser?: UserAccountModel;
  visibilityTypes?: UploadVisibilityTypeModel[];
  importFileHeaders?: ImportFileHeaderModel[];
  statusUpdatedBy?: UserAccountModel | null;
}

export const createUploadDtoFromAdminUploadModel = (
  upload: UploadModel,
): UploadDto => {
  return {
    uuid: upload.uuid,
    name: upload.name,
  };
};
